import useUsuarioStore from "../stores/UsuarioStore";
import ERP from "../ERP.mjs";
import Schema from "../Schema.mjs";
import ColaboradorService from "./ColaboradorService";
import OrdemDeServicoItemService from "./OrdemDeServicoItemService";
import PedidoDeCompraItensService from "./PedidoDeCompraItensService";
import PedidoDeCompraParcelasService from "./PedidoDeCompraParcelasService";
import PedidoDeCompraAprovadoresService from "./PedidoDeCompraAprovadoresService";
import PedidoDeCompraFollowUpService from "./PedidoDeCompraFollowUpService";
import PedidoDeCompraEnviarPedidoService from "./PedidoDeCompraEnviarPedidoService";
import RevisaoDePedidoDeCompraService from "./RevisaoDePedidoDeCompraService";
import UtilArray from "../../../utils/UtilArray.mjs";
import UtilDateTime from "@/utils/UtilDateTime";

export default {

    //==================================================================//
    //========================= CRIAR PEDIDO ===========================//
    //==================================================================//
    async criarPedido(fornecedorId,fornecedorVendedorId,fornecedorFormaDePagamento,cotacaoItensIDs,parcelasValores,observacoesGerais){

        let pedidoDeCompra;
        let usuarioStore = useUsuarioStore();

        try{

            //==================================================================//
            //======================= Pega Cotação Itens =======================//
            //==================================================================//

            let cotacaoItens = await ERP.getManyById(Schema.COTACAO_DE_PEDIDO_DE_COMPRA_ITENS,cotacaoItensIDs);
            if(cotacaoItens.status != 200){
                return cotacaoItens;
            }

            console.log(cotacaoItens);

            //==================================================================//
            //======= Pega Ordens de Serviços Itens das Cotações Itens =========//
            //==================================================================//

            let ordensDeServicoItens = cotacaoItens.data.map(({ordemDeServicoItem})=>ordemDeServicoItem);

            ordensDeServicoItens = await ERP.getManyById(Schema.ORDEM_DE_SERVICO_ITENS,ordensDeServicoItens);
            if(ordensDeServicoItens.status != 200){
                throw ordensDeServicoItens;
            }

            //==================================================================//
            //====== Pega Ordens de Serviços das Ordens de Serviço Itens =======//
            //==================================================================//

            let ordensDeServicosItensIDs = ordensDeServicoItens.data.map(({id})=>id);

            let ordensDeServicos = await ERP.getManyByValue(Schema.ORDEM_DE_SERVICO, "itens" , ordensDeServicosItensIDs);
            if(ordensDeServicos.status != 200){
                throw ordensDeServicos;
            }

            //==================================================================//
            //================ Pega Jobs das Ordens de Serviço =================//
            //==================================================================//

            let jobs = ordensDeServicos.data.map(({job})=>job);

            jobs = await ERP.getManyById(Schema.JOB, jobs);
            if(jobs.status != 200){
                throw jobs;
            }

            //==================================================================//
            //============ Pega Coordenadores de Contratos dos Jobs ============//
            //==================================================================//

            let cordenadoresDeContratos = jobs.data.map(({collaboradorId})=>collaboradorId);

            cordenadoresDeContratos = await ERP.getManyById(Schema.COLABORADOR, cordenadoresDeContratos);
            if(cordenadoresDeContratos.status != 200){
                throw cordenadoresDeContratos;
            }


            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//

            //==================================================================//
            //=========== Altera o Status do Item da Ordem de Serviço ==========//
            //==================================================================//

            let ordensDeServicoItensValores = ordensDeServicoItens.data.map((ordemDeServicoItem)=>{
                
                return{
                    id: ordemDeServicoItem.id,
                    status: "AA"
                }
            
            });

            ordensDeServicoItens = await OrdemDeServicoItemService.alterarItens(ordensDeServicoItensValores);
            if(ordensDeServicoItens.status != 200){
                throw ordensDeServicoItens;
            }

            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//

            //==================================================================//
            //================ Cria os Itens do Pedido de Compra ===============//
            //==================================================================//

            let pedidoDeCompraItensValores = cotacaoItens.data.map((cotacaoItem)=>{

                return{
                    cotacaoDePedidoDeCompraItem: cotacaoItem.id,
                    requisicaoDeCompra: cotacaoItem.requisicaoDeCompra,
                    ordemDeServicoItem: cotacaoItem.ordemDeServicoItem,
                }

            });

            let pedidoDeCompraItens = await PedidoDeCompraItensService.criaItens(pedidoDeCompraItensValores);
            if(pedidoDeCompraItens.status != 200){
                return pedidoDeCompraItens;
            }

            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//

            //==================================================================//
            //================== Cria Pedido de Compra Parcelas ================//
            //==================================================================//

            let pedidoDeCompraParcelas = await PedidoDeCompraParcelasService.criaParcelas(parcelasValores);
            if(pedidoDeCompraParcelas.status != 200){
                return pedidoDeCompraParcelas;
            }

            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//

            //==================================================================//
            //============= Cria os Aprovadores do Pedido de Compra ============//
            //==================================================================//

            let pedidoDeCompraAprovadoresCoordenadores = cordenadoresDeContratos.data.map((cordenadorDeContratos)=>{

                return{
                    aprovador: cordenadorDeContratos.id,
                }
                
            });

            let pedidoDeCompraAprovadores = await PedidoDeCompraAprovadoresService.criaAprovacaoCoordenadores(pedidoDeCompraAprovadoresCoordenadores);
            if(pedidoDeCompraAprovadores.status != 200){
                return pedidoDeCompraAprovadores;
            }

            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//

            //==================================================================//
            //======-== Pega Owners dos Aprovadores do Pedido de Compra ==-=====//
            //==================================================================//

            let colaboradoresIDs = pedidoDeCompraAprovadores.data.map(({aprovador})=>aprovador);

            let colaboradoresOwners = await ColaboradorService.pegaColaboradoresUsuario(colaboradoresIDs);
            if(colaboradoresOwners.status != 200){
                return colaboradoresOwners;
            }

            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//

            //==================================================================//
            //====================== Cria Pedido de Compra =====================//
            //==================================================================//

            let pedidoDeCompraAprovadoresIDs = pedidoDeCompraAprovadores.data.map(({id})=>id);
            let pedidoDeCompraItensIDs = pedidoDeCompraItens.data.map(({id})=>id);
            let pedidoDeCompraParcelasIDs = pedidoDeCompraParcelas.data.map(({id})=>id);

            let pedidoDeCompraValores = {
                status: "Em Aprovação de Coordenadores",
                dataCriacaoSistema: UtilDateTime.todayUTC(),
                fornecedor: fornecedorId,
                fornecedorVendedor: fornecedorVendedorId,
                fornecedorFormaDePagamento: fornecedorFormaDePagamento || "",
                aprovadores: pedidoDeCompraAprovadoresIDs,
                itens: pedidoDeCompraItensIDs,
                parcelas: pedidoDeCompraParcelasIDs,
                observacoesGerais: observacoesGerais,
                owners: UtilArray.unique(["23e308ed-4f67-4394-9a77-7228d2992dc3", usuarioStore.usuario.id, ...colaboradoresOwners.data])
            };

            pedidoDeCompra = await ERP.postOne(Schema.PEDIDO_DE_COMPRA, pedidoDeCompraValores)
            if(pedidoDeCompra.status != 200){
                return pedidoDeCompra;
            }

            console.log(pedidoDeCompra);

        }catch(e){

            console.log(e);
            return pedidoDeCompra;

        }

        return pedidoDeCompra;

    },

    //==================================================================//
    //======================== ALTERAR PEDIDO ==========================//
    //==================================================================//
    async alterarPedido(pedidosDeCompraValor = {}){

        let pedidoDeCompra;

        try{

            pedidoDeCompra = await ERP.patchOne(Schema.PEDIDO_DE_COMPRA, pedidosDeCompraValor);
            if(pedidoDeCompra.status != 200){
                throw pedidoDeCompra;
            }

            console.log(pedidoDeCompra);

        }catch(e){

            console.log(e);
            return pedidoDeCompra;

        }

        return pedidoDeCompra;

    },

    //==================================================================//
    //======================= ALTERAR PEDIDOS ==========================//
    //==================================================================//
    async alterarPedidos(pedidosDeCompraValores = []){

        let pedidosDeCompra;

        try{

            pedidosDeCompra = await ERP.patchMany(Schema.PEDIDO_DE_COMPRA, pedidosDeCompraValores);
            if(pedidosDeCompra.status != 200){
                throw pedidosDeCompra;
            }

            console.log(pedidosDeCompra);

        }catch(e){

            console.log(e);
            return pedidosDeCompra;

        }

        return pedidosDeCompra;

    },

    //==================================================================//
    //==================== DECISAO DO COORDENADOR ======================//
    //==================================================================//
    async decisaoDoCoordenador(pedidoDeCompraID = "", decisaoValores = []){

        let decisaoCoordenador;

        try{

            //==================================================================//
            //====================== Decisão do Coordenador ====================//
            //==================================================================//

            decisaoCoordenador = await PedidoDeCompraAprovadoresService.decisaoDoCoordenador(pedidoDeCompraID,decisaoValores)
            if(decisaoCoordenador.status != 200){
                throw decisaoCoordenador;
            }

        }catch(e){

            console.log(e);
            return decisaoCoordenador;

        }

        return  decisaoCoordenador

    },

    //==================================================================//
    //====================== DECISAO DO DIRETOR ========================//
    //==================================================================//
    async decisaoDoDiretor(pedidoDeCompraID = "", decisaoValores = []){

        let decisaoDiretor;

        try{

            //==================================================================//
            //======================== Decisão do Diretor ======================//
            //==================================================================//

            decisaoDiretor = await PedidoDeCompraAprovadoresService.decisaoDoDiretor(pedidoDeCompraID,decisaoValores)
            if(decisaoDiretor.status != 200){
                throw decisaoDiretor;
            }

        }catch(e){

            console.log(e);
            return decisaoDiretor;

        }

        return  decisaoDiretor

    },

    //==================================================================//
    //================ ENVIAR PEDIDO PARA FORNECEDOR ===================//
    //==================================================================//
    async enviarPedidoParaFornecedor(pedidoDeCompraID, emailFornecedorValores){

        let pedidoDeCompraEnviado;

        try{

            //==================================================================//
            //================= Enviar Pedido para Fornecedor ==================//
            //==================================================================//

            pedidoDeCompraEnviado = await PedidoDeCompraEnviarPedidoService.enviarPedidoParaFornecedor(pedidoDeCompraID,emailFornecedorValores)
            if(pedidoDeCompraEnviado.status != 200){
                throw pedidoDeCompraEnviado;
            }

        }catch(e){

            console.log(e);
            return pedidoDeCompraEnviado;

        }

        return  pedidoDeCompraEnviado

    },

    //==================================================================//
    //======================= CRIAR FOLLOWUP ===========================//
    //==================================================================//
    async criarFollowUp(pedidoDeCompraID, followUpValores){

        let pedidoDeCompra;

        try{

            //==================================================================//
            //===================== Pega Pedido de Compra ======================//
            //==================================================================//

            pedidoDeCompra = await ERP.getOneById(Schema.PEDIDO_DE_COMPRA, pedidoDeCompraID);
            if(pedidoDeCompra.status != 200){
                throw new Error("Pedido de Compra não encontrado");
            }

            //==================================================================//
            //======================== Cria Follow Up ==========================//
            //==================================================================//

            let novoFollowUp = await PedidoDeCompraFollowUpService.criaFollowUp(followUpValores);
            if(novoFollowUp.status != 200){
                throw new Error("Criar o FollowUp do Pedido de Compra falhou");
            }

            //==================================================================//
            //======================== Cria Follow Up ==========================//
            //==================================================================//

            let pedidoDeCompraFollowUps = pedidoDeCompra?.data?.followUps ?? []; 

            let pedidoDeCompraValores = {
                id: pedidoDeCompra?.data?.id,
                followUps: UtilArray.unique([...pedidoDeCompraFollowUps, novoFollowUp?.data?.id])
            }

            pedidoDeCompra = await this.alterarPedido(pedidoDeCompraValores);
            if(pedidoDeCompra.status != 200){
                throw new Error("Cancelar Pedido de Compra falhou");
            }

        }catch(e){

            console.log(e);
            return pedidoDeCompra;

        }

        return  pedidoDeCompra

    },

    //==================================================================//
    //======================== CRIAR REVISÃO ===========================//
    //==================================================================//
    async criarRevisao(pedidoDeCompraValores = {}){

        let pedidoDeCompraRevisao;

        try{

            //==================================================================//
            //=============== Cria Revisão do Pedido de Compra =================//
            //==================================================================//
            pedidoDeCompraRevisao = await RevisaoDePedidoDeCompraService.criarRevisao(pedidoDeCompraValores);
            if(pedidoDeCompraRevisao.status != 200){
                throw new Error("Falha ao Criar a Revisão do Pedido de Compra");
            }

        }catch(e){

            console.log(e);
            return pedidoDeCompraRevisao;

        }

        return pedidoDeCompraRevisao

    },

    //==================================================================//
    //======================= ALTERA REVISÃO ===========================//
    //==================================================================//
    async alteraRevisao(pedidoDeCompraValores = {}){

        let pedidoDeCompra;

        try{

            //==================================================================//
            //============== Altera Revisão do Pedido de Compra ================//
            //==================================================================//
            pedidoDeCompra = await RevisaoDePedidoDeCompraService.alteraRevisao(pedidoDeCompraValores);
            if(pedidoDeCompra.status != 200){
                throw new Error("Falha ao Alterar a Revisão do Pedido de Compra");
            }


        }catch(e){

            console.log(e);
            return pedidoDeCompra;

        }

        return pedidoDeCompra

    },

    //==================================================================//
    //====================== FINALIZA REVISÃO ==========================//
    //==================================================================//
    async finalizaRevisao(pedidoDeCompraID = ""){

        let pedidoDeCompra;

        try{

            //==================================================================//
            //============= Finaliza Revisão do Pedido de Compra ===============//
            //==================================================================//
            pedidoDeCompra = await RevisaoDePedidoDeCompraService.finalizaRevisao(pedidoDeCompraID);
            if(pedidoDeCompra.status != 200){
                throw new Error("Falha ao Finalizar a Revisão do Pedido de Compra");
            }

        }catch(e){

            console.log(e);
            return pedidoDeCompra;

        }

        return pedidoDeCompra

    },

    //==================================================================//
    //======================= CANCELA PEDIDO ===========================//
    //==================================================================//
    async cancelaPedido(pedidoDeCompraValores = {}){

        let pedidoDeCompra;

        try{

            //==================================================================//
            //=================== Pega o Pedido de Compra ======================//
            //==================================================================//

            pedidoDeCompra = await ERP.getOneById(Schema.PEDIDO_DE_COMPRA, pedidoDeCompraValores.id);
            if(pedidoDeCompra.status != 200){
                throw pedidoDeCompra;
            }

            //==================================================================//
            //=============== Pega o Pedido de Compra Itens ====================//
            //==================================================================//

            let pedidoDeCompraItens = await ERP.getManyById(Schema.PEDIDO_DE_COMPRA_ITENS, pedidoDeCompra.data.itens);
            if(pedidoDeCompraItens.status != 200){
                throw pedidoDeCompraItens;
            }

            //==================================================================//
            //==== Pega Ordens de Serviço Item dos Itens do Pedido de Compra ===//
            //==================================================================//

            let ordemDeServicoItensIDs = pedidoDeCompraItens?.data?.map(({ordemDeServicoItem})=>ordemDeServicoItem);

            let ordemDeServicoItens = await ERP.getManyById(Schema.ORDEM_DE_SERVICO_ITENS, ordemDeServicoItensIDs);
            if(ordemDeServicoItens.status != 200){
                throw ordemDeServicoItens;
            }

            //==================================================================//
            //=============== Pega o Pedido de Compra Parcelas =================//
            //==================================================================//

            let pedidoDeCompraParcelas = await ERP.getManyById(Schema.PEDIDO_DE_COMPRA_PARCELAS, pedidoDeCompra.data.parcelas);
            if(pedidoDeCompraParcelas.status != 200){
                throw pedidoDeCompraParcelas;
            }

            //==================================================================//
            //=========== Pega os Aprovadores do Pedido de Compra ==============//
            //==================================================================//

            let pedidoDeCompraAprovadores = await ERP.getManyById(Schema.PEDIDO_DE_COMPRA_APROVADORES, pedidoDeCompra.data.aprovadores);
            if(pedidoDeCompraAprovadores.status != 200){
                throw pedidoDeCompraAprovadores;
            }

            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//

            //==================================================================//
            //==================== Cancela as Aprovações =======================//
            //==================================================================//

            let pedidoDeCompraAprovacoesCancelarValores = pedidoDeCompraAprovadores.data.map((pedidoDeCompraAprovador)=>{
            
                return{
                    id: pedidoDeCompraAprovador.id,
                    status: "Cancelado"
                }

            });

            let pedidoDeCompraAprovacoesCancelar = await PedidoDeCompraAprovadoresService.alteraAprovadores(pedidoDeCompraAprovacoesCancelarValores);
            if(pedidoDeCompraAprovacoesCancelar.status != 200){
                throw pedidoDeCompraAprovacoesCancelar;
            }

            //==================================================================//
            //====================== Cancela os Itens ==========================//
            //==================================================================//

            let pedidoDeCompraItensCancelarValores = pedidoDeCompraItens.data.map((pedidoDeCompraItem)=>{
            
                return{
                    id: pedidoDeCompraItem.id,
                    status: "Cancelado"
                }

            });

            let pedidoDeCompraItensCancelar = await PedidoDeCompraItensService.alteraItens(pedidoDeCompraItensCancelarValores);
            if(pedidoDeCompraItensCancelar.status != 200){
                throw pedidoDeCompraItensCancelar;
            }

            //==================================================================//
            //====================== Cancela as Parcelas =======================//
            //==================================================================//

                let pedidoDeCompraParcelasCancelarValores = pedidoDeCompraParcelas.data.map((pedidoDeCompraParcela)=>{
            
                return{
                    id: pedidoDeCompraParcela.id,
                    status: "Cancelada"
                }

            });

            let pedidoDeCompraParcelasCancelar = await PedidoDeCompraParcelasService.alteraParcelas(pedidoDeCompraParcelasCancelarValores);
            if(pedidoDeCompraParcelasCancelar.status != 200){
                throw pedidoDeCompraParcelasCancelar;
            }

            //==================================================================//
            //========= Retorne as Ordens de Serviço Item para AC ==============//
            //==================================================================//

            let ordemDeServicoItensRetornarValores = ordemDeServicoItens.data.map((ordemDeServicoItem)=>{
            
                return{
                    id: ordemDeServicoItem.id,
                    status: "AC",
                }

            });

            let ordemDeServicoItensRetornar = await OrdemDeServicoItemService.alterarItens(ordemDeServicoItensRetornarValores);
            if(ordemDeServicoItensRetornar.status != 200){
                throw ordemDeServicoItensRetornar;
            }

            //==================================================================//
            //========== Envie o Pedido de Compra para Cancelado ===============//
            //==================================================================//

            let pedidoDeCompraCancelarValores = {
                id: pedidoDeCompra.data.id,
                status: "Cancelado",
                observacaoParaCancelamento: pedidoDeCompraValores.observacaoParaCancelamento
            }

            let pedidoDeCompraCancelar = await this.alterarPedido(pedidoDeCompraCancelarValores);
            if(pedidoDeCompraCancelar.status != 200){
                throw pedidoDeCompraCancelar;
            }

        }catch(e){

            console.log(e);
            return pedidoDeCompra;

        }

        return pedidoDeCompra

    },

    



















}